import {useConfig} from "@/plugins/obscore";
import {defineStore} from "@/models/userstore/userstore";
const Models = require.context('@/models/userstore/', true, /.*/i);

export default class UserStoreManager {
    store = null
    initStore() {
        const auth = useConfig().auth
        const { default: config } = Models(`./${auth.authMethod}userstore`)
        this.store = defineStore(config)
    }
    useUserStore() {
        if (!this.store)
            this.initStore()

        return this.store
    }
}